import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
} from 'axis-components';
import { CommonModule } from '@angular/common';
import { BaseRules, TextValues } from './arkansas.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PersonalInjuryProtectionSelection } from '../../../config/pip-constants';

@Component({
  selector: 'app-arkansas',
  templateUrl: './arkansas.component.html',
  styleUrls: ['./arkansas.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
  ],
})
export class ArkansasComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('arkansas', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('arkansas', null);
    }
  }

  override dynamicRuleQueryBuilder(): string {
    // Logic based on Personal Injury Protection Selection and Additional Options
    if (
      this.baseRulesService.personalInjuryProtectionSelection ===
      PersonalInjuryProtectionSelection.IndividualStateCoverage
    ) {
      return 'showAll';
    }
  }
}
